// MoffAPI
import axios, { AxiosInstance } from 'axios';
import { Dispatch } from 'redux';
import * as Moff from '../constants/MoffAPI';
import * as AWS from '../constants/AWS';
import * as KirokuConst from '../constants/Kiroku';

const API_VERSION: string = 'v1';

// apiUrlUpdateMonthlyの切り替えURL定義
// ロコモ予防トレーニング・詳細用
const LOCOMO_URL: string = `${API_VERSION}/dashboard/locomotraining/users/`;

// 日常生活動作トレーニング・詳細用
const ADL_URL: string = `${API_VERSION}/dashboard/adltraining/users/`;

export class MoffAPI {
  /** インスタンス */
  private static _instance: MoffAPI;
  private axiosInstance: AxiosInstance;

  /** インスタンスの取得 */
  public static get instance(): MoffAPI | null {
    // _inctanceが存在しない場合に、new MoffAPI()を実行する。
    if (!this._instance) {
      this._instance = new MoffAPI();
      
      // .envの設定 
      const API_BASE_URL = String(process.env.REACT_APP_MOFF_API_URL);

      const userPool = AWS.userPool();
      const cognitoUser = userPool.getCurrentUser();
      if (cognitoUser === null) {
        return null;
      }

      const self = this;
      cognitoUser.getSession(function(err: any, session: any) {
        if (err) {
          return;
        }

        if (session) {
          self._instance.axiosInstance = axios.create({
            baseURL: API_BASE_URL,
            headers: {
              'Authorization': session.getIdToken().getJwtToken()
            }
          });
        }
      });
    }

    // 生成済みのインスタンスを返す
    return this._instance;
  }

  // Non-Redux Backup.
  // public getUser(userId: string, callback: Function): void {
  //   const url = `${API_VERSION}/users/${userId}`;
  //   this.axiosInstance.get(url)
  //     .then(function(response: any) {
  //       callback(response.data.user, null);
  //     })
  //     .catch(function(error: any) {
  //       callback(null, error);
  //     });
  // }

  // Redux.
  // 利用者一覧取得(1人)
  public getUser(
    userId: string, requestFunc: Function, fetchedFunc: Function): any {
    const self = this;
    const url = `${API_VERSION}/users/${userId}`;
    return (dispatch: Dispatch<any>) => {
      dispatch(requestFunc());
      this.axiosInstance.get(url)
        .then(function(response: any) {
          dispatch(fetchedFunc(Moff.LOADING, null));
          dispatch(fetchedFunc(Moff.SUCCESS, response.data.user));
        })
        .catch(function(error: any) {
          self.showAxiosError('getUser', error);
          dispatch(fetchedFunc(Moff.ERROR, error));
        });
    };
  }

  // Non-Redux Backup.
  // public getTraining(callback: Function): void {
  //   const url = `${API_VERSION}/training`;
  //   this.axiosInstance.get(url)
  //     .then(function(response: any) {
  //       callback(response.data.trainings, null);
  //     })
  //     .catch(function(error: any) {
  //       callback(null, error);
  //     });
  // }

  // Redux.
  // トレーニング取得
  public getTraining(requestFunc: Function, fetchedFunc: Function): any {
    const self = this;
    const url = `${API_VERSION}/training`;
    return (dispatch: Dispatch<any>) => {
      dispatch(requestFunc());
      this.axiosInstance.get(url)
        .then(function(response: any) {
          dispatch(fetchedFunc(Moff.LOADING, null));
          dispatch(fetchedFunc(Moff.SUCCESS, response.data.trainings));
        })
        .catch(function(error: any) {
          self.showAxiosError('getTraining', error);
          dispatch(fetchedFunc(Moff.ERROR, error));
        });
    };
  }

  // Non-Redux Backup.
  // public getUsers(callback: Function): void {
  //   this.axiosInstance.get('v1/users')
  //       .then(function(response: any) {
  //           callback(response.data.users, null);
  //       })
  //       .catch(function(error: any) {
  //           callback(null, error);
  //       });
  // }

  // Redux.
  // 利用者一覧取得(複数)
  public getUsers(requestFunc: Function, fetchedFunc: Function): any {
    const self = this;
    const url = `${API_VERSION}/users`;
    return (dispatch: Dispatch<any>) => {
      dispatch(requestFunc());
      this.axiosInstance.get(url)
        .then(function(response: any) {
          dispatch(fetchedFunc(Moff.LOADING, null));
          dispatch(fetchedFunc(Moff.SUCCESS, response.data.users));
        })
        .catch(function(error: any) {
          self.showAxiosError('getUsers', error);
          dispatch(fetchedFunc(Moff.ERROR, error));
        });
    };
  }

  /**
   * 施設情報取得.
   *
   * @param {Function} requestFunc
   * @param {Function} fetchedFunc
   * @returns {*}
   * @memberof MoffAPI
   */
  public getInstitutions(requestFunc: Function, fetchedFunc: Function): any {
    const self = this;
    const url = `${API_VERSION}/institutions`;
    return (dispatch: Dispatch<any>) => {
      dispatch(requestFunc());
      this.axiosInstance.get(url)
        .then(function(response: any) {
          dispatch(fetchedFunc(Moff.LOADING, null));
          dispatch(fetchedFunc(Moff.SUCCESS, response.data));
        })
        .catch(function(error: any) {
          self.showAxiosError('getInstitutions', error);
          dispatch(fetchedFunc(Moff.ERROR, error));
        });
    };
  }

  // Non-Redux Backup.
  // public getMonthlyDataSize(
  //   apiUrlUpdateMonthly: string, userId: string, yearmonth: string, callback: Function): void {
  //   var url = `apiUrlUpdateMonthly${userId}/month/${yearmonth}`;
  //   this.axiosInstance.get(url)
  //     .then(function(response: any) {
  //       var obj = response.data.history;
  //       var size = 0, key;
  //       for (key in obj) {
  //         if (obj.hasOwnProperty(key)) { size++; }
  //       }
  //       callback(yearmonth, size, null);
  //     })
  //     .catch(function(error: any) {
  //       callback(null, error);
  //     });
  // }

  // Redux.
  // 月間データサイズ取得(typeは1 or 2, yearmonthは'yyyy-mm'形式)
  public getMonthlyDataSize(
    type: number, userId: string, yearmonth: string, requestFunc: Function, fetchedFunc: Function): any {
    let {isError, updateMonthlyURL} = this.getUpdateMonthlyURL(type);

    return (dispatch: Dispatch<any>) => {
      dispatch(requestFunc());

      const self = this;
      const url = `${updateMonthlyURL}${userId}/month/${yearmonth}`;
      if (isError) {
        dispatch(fetchedFunc(Moff.ERROR, '不明なタイプです.'));
        return;
      }

      this.axiosInstance.get(url)
        .then(function(response: any) {
          const obj = response.data.history;
          let size = 0, key;
          for (key in obj) {
            if (obj.hasOwnProperty(key)) { size++; }
          }

          dispatch(fetchedFunc(Moff.SUCCESS, {yearmonth, size}));
        })
        .catch(function(error: any) {
          self.showAxiosError('getMonthlyDataSize', error);
          dispatch(fetchedFunc(Moff.ERROR, error));
        });
    };
  }

  // Non-Redux Backup.
  // public getMonthlyData(apiUrlUpdateMonthly: string, userId: string, yearmonth: string, callback: Function): void {
  //   var url = `apiUrlUpdateMonthly${userId}/month/${yearmonth}`;
  //   this.axiosInstance.get(url)
  //     .then(function(response: any) {
  //       callback(response.data.history, null);
  //     })
  //     .catch(function(error: any) {
  //       callback(null, error);
  //     });
  // }

  // Redux.
  // 月間データ取得(typeは1 or 2, yearmonthは'yyyy-mm'形式)
  public getMonthlyData(
    type: number, userId: string, yearmonth: string, requestFunc: Function, fetchedFunc: Function): any {
    let {isError, updateMonthlyURL} = this.getUpdateMonthlyURL(type);

    return (dispatch: Dispatch<any>) => {
      dispatch(requestFunc());

      const self = this;
      const url = `${updateMonthlyURL}${userId}/month/${yearmonth}`;
      if (isError) {
        dispatch(fetchedFunc(Moff.ERROR, '不明なタイプです.'));
        return;
      }

      this.axiosInstance.get(url)
        .then(function(response: any) {
          dispatch(fetchedFunc(Moff.SUCCESS, response.data.history, type));
        })
        .catch(function(error: any) {
          self.showAxiosError('getMonthlyData', error);
          dispatch(fetchedFunc(Moff.ERROR, error));
        });
    };
  }

  // Non-Redux Backup.
  // public getFunctionalTrainingHistory(
  //   userId: string, startDate: string, endDate: string, callback: Function): void {
  //   this.axiosInstance.get(
  //     `v1/dashboard/functionaltraining/users/${userId}/date/${startDate}/${endDate}`)
  //     .then(function(response: any) {
  //       callback(response.data.history, null);
  //     })
  //     .catch(function(error: any) {
  //       callback(null, error);
  //     });
  // }

  // Redux.
  // トレーニング履歴・取得
  // 注意
  // startDate, endDateを'2018-01', '2018-02'の月までの形式ではなく
  // startDate, endDateを'2018-01-26', '2018-02-02'のように日も忘れずに指定する事。
  public getFunctionalTrainingHistory(
    userId: string, startDate: string, endDate: string, requestFunc: Function, fetchedFunc: Function): any {
    const self = this;
    const url = `${API_VERSION}/dashboard/functionaltraining/users/${userId}/date/${startDate}/${endDate}`;
    return (dispatch: Dispatch<any>) => {
      dispatch(requestFunc());
      this.axiosInstance.get(url)
        .then(function(response: any) {
          dispatch(fetchedFunc(Moff.SUCCESS, response.data.history));
        })
        .catch(function(error: any) {
          self.showAxiosError('getFunctionalTrainingHistory', error);
          dispatch(fetchedFunc(Moff.ERROR, error));
        });
    };
  }

  // Non-Redux Backup.
  // public postFunctionalTrainingHistory(userId: string, params: any, callback: Function): void {
  //   this.axiosInstance.post(`v1/dashboard/functionaltraining/users/${userId}`, params)
  //     .then(function(response: any) {
  //       callback(response.data.training, null);
  //     })
  //     .catch(function(error: any) {
  //       callback(null, error);
  //     });
  // }

  // Redux.
  // トレーニング履歴・追加
  public postFunctionalTrainingHistory(
    userId: string, params: KirokuConst.NewParamFormat, requestFunc: Function, fetchedFunc: Function): any {
    const self = this;
    const url = `${API_VERSION}/dashboard/functionaltraining/users/${userId}`;
    return (dispatch: Dispatch<any>) => {
      dispatch(requestFunc());
      this.axiosInstance.post(url, params)
        .then(function(response: any) {
          dispatch(fetchedFunc(Moff.SUCCESS, response.data.training));
        })
        .catch(function(error: any) {
          self.showAxiosError('postFunctionalTrainingHistory', error);
          dispatch(fetchedFunc(Moff.ERROR, error));
        });
    };
  }

  // Non-Redux Backup.
  // public putFunctionalTrainingHistory(userId: string, params: any,
  //                                     timeTexConverted: string, callback: Function): void {
  //   this.axiosInstance.put(
  //     `v1/dashboard/functionaltraining/users/${userId}/datetime/${timeTexConverted}`, params)
  //     .then(function(response: any) {
  //       callback(response.data.training, null);
  //     })
  //     .catch(function(error: any) {
  //       callback(null, error);
  //     });
  // }

  // Redux.
  // トレーニング履歴・変更
  public putFunctionalTrainingHistory(
    userId: string, params: KirokuConst.UpdateParamFormat, timeTexConverted: string,
    requestFunc: Function, fetchedFunc: Function): any {
    const self = this;
    const url = `${API_VERSION}/dashboard/functionaltraining/users/${userId}/datetime/${timeTexConverted}`;
    return (dispatch: Dispatch<any>) => {
      dispatch(requestFunc());
      this.axiosInstance.put(url, params)
        .then(function(response: any) {
          dispatch(fetchedFunc(Moff.SUCCESS, response.data.training));
        })
        .catch(function(error: any) {
          self.showAxiosError('putFunctionalTrainingHistory', error);
          dispatch(fetchedFunc(Moff.ERROR, error));
        });
    };
  }

  // Non-Redux Backup.
  // public deleteFunctionalTrainingHistory(userId: string, timeTexConverted: string, callback: Function): void {
  //   this.axiosInstance.delete(
  //     `v1/dashboard/functionaltraining/users/${userId}/datetime/${timeTexConverted}`)
  //     .then(function(response: any) {
  //       callback(response.data.status, null);
  //     })
  //     .catch(function(error: any) {
  //       callback(null, error);
  //     });
  // }

  // Redux.
  // トレーニング履歴・削除
  public deleteFunctionalTrainingHistory(
    userId: string, timeTexConverted: string, requestFunc: Function, fetchedFunc: Function): any {
    const self = this;
    const url = `${API_VERSION}/dashboard/functionaltraining/users/${userId}/datetime/${timeTexConverted}`;
    return (dispatch: Dispatch<any>) => {
      dispatch(requestFunc());
      this.axiosInstance.delete(url)
        .then(function(response: any) {
          dispatch(fetchedFunc(Moff.SUCCESS, response.data.status));
        })
        .catch(function(error: any) {
          self.showAxiosError('deleteFunctionalTrainingHistory', error);
          dispatch(fetchedFunc(Moff.ERROR, error));
        });
    };
  }

  /** プライベートコンストラクタ */
  private constructor() {
  }

  // typeからURL変換
  private getUpdateMonthlyURL(type: number) {
    let isError: boolean = false;
    let updateMonthlyURL = '';

    switch (type) {
      case Moff.LOCOMO_TYPE:
        // ロコモ予防トレーニング・詳細用
        updateMonthlyURL = LOCOMO_URL;
        break;
      case Moff.ADL_TYPE:
        // 日常生活動作トレーニング・詳細用
        updateMonthlyURL = ADL_URL;
        break;
      default:
        isError = true;
        break;
    }

    return {isError, updateMonthlyURL};
  }

  // エラーポップアップ.
  // apiNameはどのAPIによるものか.
  private showAxiosError(apiName: string, error: any) {
    if (error.toString().indexOf('Network Error') !== -1) {
      const errorMessage = '通信エラーが発生しました。インターネット接続が出来ることを確認してから再度ページを読み込み直して下さい。';
      alert(errorMessage);
    } else if (error.toString().indexOf('timeout') !== -1) {
      const errorMessage = '通信エラーが発生しました。インターネット接続が良好な環境で、再度ページを読み込み直して下さい。';
      alert(errorMessage);
    }

    // ログインへ.
    window.location.href = '/';
  }
}



// WEBPACK FOOTER //
// ./src/api/MoffAPI.tsx